import React from 'react';
import { PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer } from 'recharts';

// Paleta de cores moderna (inspirada no Power BI)
const COLORS = ["#0078d4", "#f7630c", "#107c10", "#ffb900", "#d83b01", "#00b7c3", "#8764b8"];

const PieChartSimples = ({ data, title }) => {
  const formatNumber = (value) => new Intl.NumberFormat('pt-BR').format(value);

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      const dataPoint = payload[0];
      return (
        <div className="shadow-lg rounded" style={{ backgroundColor: '#fff', border: 'none', padding: '12px', minWidth: '150px' }}>
          <div className="d-flex justify-content-between align-items-center mb-1">
             <span style={{ color: dataPoint.payload.fill, fontSize: '0.9rem', marginRight: '10px', fontWeight: 'bold' }}>
               ● {dataPoint.name}:
             </span>
             <span style={{ fontWeight: 600, color: '#201f1e' }}>
               {formatNumber(dataPoint.value)} unid.
             </span>
          </div>
        </div>
      );
    }
    return null;
  };

  return (
    <div className="d-flex flex-column align-items-center w-100 bg-white rounded p-2">
      {title && <h5 className="text-secondary text-center mb-3">{title}</h5>}
      <ResponsiveContainer width="100%" height={350}>
        <PieChart>
          <Pie
            data={data}
            cx="50%"
            cy="50%"
            innerRadius="50%" // Transforma em um Donut Chart
            outerRadius="80%"
            paddingAngle={2}
            dataKey="value"
            nameKey="name"
            label={({ percent }) => `${(percent * 100).toFixed(1)}%`}
          >
            {data.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
            ))}
          </Pie>
          <Tooltip content={<CustomTooltip />} />
          <Legend verticalAlign="bottom" height={36} iconType="circle" />
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
};

export default PieChartSimples;